import React, { memo, useEffect } from 'react';
import ReactModal from 'react-modal';

interface Props {
	children?: React.ReactNode;
}

const ModalLayer = ({ children }: Props) => {
	useEffect(() => {
		ReactModal.setAppElement('#main');
	}, []);
	return <div id="main">{children}</div>;
};
const _ModalLayerExport = memo(ModalLayer);

export { _ModalLayerExport as ModalLayer };
